import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Profile } from '../../model/profile';
import { BasicOwnerConfig } from '../../model/basic-owner-config';

@Injectable()
export class ProfileService {
  constructor(
    protected _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._config = config.apiEndpointV2 + '/systemowner/config';
    this._logo = config.apiEndpointV2 + '/systemowner/logo';
    this._profileGet = config.apiEndpointV2 + '/systemowner/profile';
  }

  private _config: string;
  private _logo: string;
  private _profileGet: string;

  get(): Observable<Profile> {
    return this._client.get<Profile>(this._profileGet);
  }

  getConfig(): Observable<BasicOwnerConfig> {
    return this._client.get<BasicOwnerConfig>(this._config);
  }

  getPhoto(): Observable<string> {
    return this._client.get<string>(this._logo);
  }
}
